import "./App.css";
import Blog from "./Components/Blog";
import Main from "./Components/Main";

import {
  createBrowserRouter,
  // createRoutesFromElements, 
  RouterProvider,
  // Route 
} from 'react-router-dom';

function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main />,
    },
    {
      path: "/blog",
      element: <Blog />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
